import { Middleware } from '@nuxt/types';
import { Logger } from '~/helpers/logger';
import { redirectToFallback } from '~/helpers/notFoundFallback';

const PARTNER_EXISTS_QUERY = `
query partnerExists($filter: PartnerFilterInput) {
  partners(filter: $filter, pageSize: 1) {
    items {
      slug
    }
  }
}
`;

interface PartnerExistsQuery {
  partners?: { items?: unknown[] };
}

/**
 * /partner/:slug - sends unknown partners to the closest generic page instead of a 404.
 */
const partnerMiddleware: Middleware = async (context) => {
  const { slug } = context.route.params;

  const { data: rawData, errors } = await context.app.$vsf.$magento.api.customQuery({
    query: PARTNER_EXISTS_QUERY,
    queryVariables: { filter: { slug: { eq: slug } } },
  });

  const data = rawData as PartnerExistsQuery | undefined;

  Logger.debug('middleware/partner/result', { data, errors });

  if (errors?.length || !data?.partners?.items?.length) redirectToFallback(context);
};

export default partnerMiddleware;
